import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IGoal, IGoalAction, ISurveyQuestionItemDTO } from '../../major_explorer_interface';

interface IChoiceQuestionFunctionModel {
  selected?: IGoalAction;
  _userSelected: IGoal[];
}

export class ChoiceQuestionFunction {
  models: IChoiceQuestionFunctionModel;

  constructor(
    private saveChoiceQuestionCommand: ICommand,
    private myIntakeHistoryModel: any,
    private ItemPresenterEnum: any
  ) {}

  initialize(item: ISurveyQuestionItemDTO): void {
    this.models = {
      selected: undefined,
      _userSelected: []
    };

    item._options = _4.sortBy(item._options, 'rank');

    _4.forEach(item._options, (option: IGoal) => {
      if (!_4.isUndefined(option._action.value) && option._action.value === 1) {
        this.models.selected = option._action;
        this.models._userSelected[0] = option;
      }
    });

    this.myIntakeHistoryModel.update(this.ItemPresenterEnum.CHOICE.key, this.models._userSelected);
  }

  validate(item: ISurveyQuestionItemDTO): boolean {
    if (_4.isEmpty(item._options)) {
      return true;
    } else {
      return (
        _4.find(item._options, (option: IGoal) => {
          return option._action.value > 0;
        }) !== undefined
      );
    }
  }

  item_onChange(item: ISurveyQuestionItemDTO, optionId: number) {
    _4.each(item._options, (option: IGoal) => {
      if (option.id === optionId) {
        option._action.value = 1;
        this.models._userSelected[0] = option;
      } else {
        option._action.value = 0;
      }
    });

    if (optionId !== -1) {
      this.myIntakeHistoryModel.update(this.ItemPresenterEnum.CHOICE.key, this.models._userSelected);
      this.saveChoiceQuestionCommand(item);
    }
  }
}

angular.module('major-explorer-data').service('choiceQuestionFn', ChoiceQuestionFunction);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/functions/choice_question_fn.ts